/**
 * ProviderDetail Component
 *
 * Redirects to encounters tab filtered by provider
 * (Provider details are now shown in the encounters view)
 */

import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

export const ProviderDetail: React.FC = () => {
  const navigate = useNavigate();
  const { userId, organizationId } = useParams<{ userId: string; organizationId?: string }>();

  // Redirect to encounters tab with provider filter
  useEffect(() => {
    if (userId) {
      if (organizationId) {
        navigate(`/admin-v2/jotaudit/${organizationId}?tab=encounters&provider=${userId}`, { replace: true });
      } else {
        navigate(`/jotaudit?tab=encounters&provider=${userId}`, { replace: true });
      }
    }
  }, [userId, organizationId, navigate]);

  // Show loading state while redirecting
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <CircularProgress />
    </Box>
  );
};

export default ProviderDetail;
